<template>
  <div id="app">
    <!-- 顶栏、底栏与首页同一 DOM/类名/切图（见 Header、Footer），全路由共用 -->
    <Header />
    <main class="main" :class="{ 'main--flush': isHome }">
      <router-view />
      <Connect />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Connect from "./components/connect.vue";
export default {
  components: {
    Header,
    Footer,
    Connect,
  },
  computed: {
    isHome() {
      // console.log(12111, this.$route);
      return ["Home", "SolutionDetail"].includes(this.$route.name);
    },
  },
  watch: {
    "$route.path"() {
      this.applyHeaderScrollState();
    },
  },
  mounted() {
    this._onAppScroll = () => this.applyHeaderScrollState();
    document.body.addEventListener("scroll", this._onAppScroll, { passive: true });
    this.applyHeaderScrollState();
  },
  beforeDestroy() {
    if (this._onAppScroll) {
      window.removeEventListener("scroll", this._onAppScroll);
      this._onAppScroll = null;
    }
    if (typeof document !== "undefined" && document.body) {
      document.body.classList.remove("header-scrolled");
    }
  },
  methods: {
    applyHeaderScrollState() {
      // console.log(1234, document, document.body.scrollTop);
      if (typeof document === "undefined" || !document.body) return;
      const HOME_HEADER_SOLID_AT = 425;
      // 首页：scrollY ≥500 时顶栏白底；内页：始终白底
      const shouldSolid = document.body.scrollTop >= HOME_HEADER_SOLID_AT;
      // console.log(shouldSolid, document.body.scrollTop);
      document.body.classList.toggle("header-scrolled", shouldSolid);
    },
  },
};
</script>

<style>
* {
  scrollbar-width: none;
  /* overflow-y: auto; */
  /* overflow-x: hidden; */
}
html {
  scroll-behavior: smooth;
  /* scroll-padding-top: 88px; */
}
body {
  font-family: "Noto Sans SC", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  color: #333;
  line-height: 1.6;
}
/* 固定顶栏占位：头部高度 88px，避免子页内容钻进顶栏下 */
.main {
  /* padding-top: 88px; */
}
.main--flush {
  padding-top: 0;
}

.common-hero {
  height: 545px;
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
<!-- <style src="@/assets/lanhu-shouye/lanhu-common.css"></style> -->
<!-- <style src="@/assets/lanhu-shouye/lanhu-index.css"></style> -->
